import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { getFirestoreInstance } from './firestore';
import type { Contract } from '@gigdriver/domain';
import { fromFirestore } from './serde';
import { getGig } from './gigs';
import { callable } from './functions';

function contractsCollection(orgId: string, gigId: string) {
  return collection(getFirestoreInstance(), 'organizations', orgId, 'gigs', gigId, 'contracts');
}

export async function getContract(orgId: string, gigId: string, contractId: string): Promise<Contract | null> {
  const ref = doc(getFirestoreInstance(), 'organizations', orgId, 'gigs', gigId, 'contracts', contractId);
  const snap = await getDoc(ref);
  return snap.exists() ? fromFirestore<Contract>(snap.data()) : null;
}

export async function getGigContracts(orgId: string, gigId: string): Promise<Contract[]> {
  const snap = await getDocs(contractsCollection(orgId, gigId));
  return snap.docs.map(d => fromFirestore<Contract>(d.data()));
}

// The gig's current contract, if any — resolved via Gig.activeContractId,
// mirrors quotes.ts's getActiveQuote.
export async function getActiveContract(orgId: string, gigId: string): Promise<Contract | null> {
  const gig = await getGig(orgId, gigId);
  if (!gig?.activeContractId) return null;
  return getContract(orgId, gigId, gig.activeContractId);
}

export const sendContractForSignature = callable<{ orgId: string; gigId: string }, { contractId: string }>(
  'sendContractForSignature',
);

export const getContractPdf = callable<{ orgId: string; gigId: string; contractId: string }, { url: string }>(
  'getContractPdf',
);
